// extracted by mini-css-extract-plugin
module.exports = {"tableTitleCell":"GroupWorkPlaceInformation_tableTitleCell__38VmD","dataClassCell":"GroupWorkPlaceInformation_dataClassCell__1L4U7"};